export const RegisterLedgerEntryTypes = {
    Sale : 1,
    Void : 2,
    Return : 3,
    PaymentChange : 4,
    CashDropPOS : 5,
    CashDropBackend : 6,
    CashDropBulk : 7,
    CloseoutPOS : 8,
    CloseoutBackend : 9,
    CloseoutBulk : 10,
    AdjustmentPOS : 11,
    AdjustmentBackend : 12,
    Transfer : 13,
    RegisterStartingBalance : 14
};



// WEBPACK FOOTER //
// ./ui_src/app/constants/RegisterLedgerConstants.jsx